import { Component, ChangeDetectionStrategy, input, output, OnChanges, SimpleChanges, OnDestroy } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-modal',
  imports: [CommonModule],
  templateUrl: './modal.component.html',
  styleUrls: ['./modal.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ModalComponent implements OnChanges, OnDestroy {
  title = input('');
  isOpen = input(false);
  size = input<'sm' | 'md' | 'lg' | 'xl' | 'fullscreen'>('md');

  closed = output<void>();

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['isOpen']) {
      this.toggleBodyScroll(changes['isOpen'].currentValue);
    }
  }

  ngOnDestroy(): void {
    // Ensure scroll is restored when component is destroyed
    this.toggleBodyScroll(false);
  }

  private toggleBodyScroll(disable: boolean): void {
    if (disable) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }
  }

  close(): void {
    this.closed.emit();
  }

  onBackdropClick(event: Event): void {
    // Only close if clicked on backdrop, not on modal content
    if (event.target === event.currentTarget) {
      this.close();
    }
  }

  onEscapeKey(event: KeyboardEvent): void {
    if (event.key === 'Escape') {
      this.close();
    }
  }
}
